import { render, staticRenderFns } from "./CompetitionListComponent.vue?vue&type=template&id=8a815aac&scoped=true&"
import script from "./CompetitionListComponent.vue?vue&type=script&lang=js&"
export * from "./CompetitionListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a815aac",
  null
  
)

export default component.exports